import { Contracts as _Contracts } from '@models/API/companies/contracts.model';
import { Reports as _Reports } from '@models/API/companies/reports.model';

export namespace Companies {
  export import Contracts = _Contracts;
  export import Reports = _Reports;
}
